import React from 'react'
import JSONInput from 'react-json-editor-ajrm'

export const DisplayJson = ({ value }) => {
  if (typeof value === 'object') {
    return (
      <JSONInput
        id='json-input'
        placeholder={value || {}}
        viewOnly
        height='400px'
        width='600px'
        locale='es'
        colors={{
          default: 'black',
          background: 'white',
          string: 'red',
        }}
      />
    )
  }
  return value
}
